module.exports = __webpack_public_path__ + "static/img/offline.9297114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offline.jpg
// module id = 763
// module chunks = 2 3 4 5 8